"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wizard = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("./Button");
var Wizard = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.currentPage, currentPage = _b === void 0 ? 0 : _b, onCurrentPageChange = _a.onCurrentPageChange, onSubmit = _a.onSubmit, extraButtons = _a.extraButtons;
    if (children.length === 0) {
        throw new Error("Element must have at least one child");
    }
    // Ensure we are not out of bounds
    currentPage = Math.min(children.length - 1, currentPage);
    currentPage = Math.max(0, currentPage);
    var page = children[currentPage];
    var prevButton = currentPage > 0 ? (react_1.default.createElement("span", { className: "ml-1" },
        react_1.default.createElement(Button_1.Button, { onClick: function () { return onCurrentPageChange(currentPage - 1); } }, "Previous"))) : null;
    var nextButton = currentPage < children.length - 1 ? (react_1.default.createElement("span", { className: "ml-1" },
        react_1.default.createElement(Button_1.Button, { onClick: function () { return onCurrentPageChange(currentPage + 1); } }, "Next"))) : null;
    var submitButton = currentPage === children.length - 1 && onSubmit ? (react_1.default.createElement("span", { className: "ml-1" },
        react_1.default.createElement(Button_1.Button, { color: "green", onClick: onSubmit }, "Submit"))) : null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", null, page),
        react_1.default.createElement("div", { className: "flex justify-end" },
            extraButtons,
            prevButton,
            nextButton,
            submitButton)));
};
exports.Wizard = Wizard;
